module.exports = __webpack_public_path__ + "static/media/orange-background.60f5dfc1.svg";